import { render, staticRenderFns } from "./SavedPlanTeachingPeriod.vue?vue&type=template&id=607ffb4a&"
import script from "./SavedPlanTeachingPeriod.vue?vue&type=script&lang=js&"
export * from "./SavedPlanTeachingPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports